import { useContext, useEffect, useState } from 'react';
import { DataContext } from '../data/DataContext';
import { DropDown, CheckBox2, Input, Tooltip } from '../components';
import { GetResumen } from '../data/Help'
import { GetResumenRate } from '../../../utils/helpMain'
import Modal from 'react-modal';
import http from '../../../services/http';
import { endPoints } from '../../../utils/constanst';
import { GetDataRates } from '../data/Help'
import { idDiscountManual, idDiscountAutoNew } from '../data/MochaData'



const Step5 = () => {
    const { AutoCR, setAutoCR, changeHandler } = useContext(DataContext);
    // const [resumen, setResumen] = useState(GetResumen(AutoCR))
    const [resumen, setResumen] = useState({} as IRatesResumen);
    const onChange = (property: string, value: string) => setAutoCR({ ...AutoCR, [property]: value });
    const [openModalDisconunt, setOpenModalDiscount] = useState(false)
    const [isChecked, setIsChecked] = useState(AutoCR.idDiscount);
    const [validMaxDiscount, setValidMaxDiscount] = useState(false);

    useEffect(() => {
        BuildRate()
    }, [])


    useEffect(() => {
        // setResumen(GetResumen(AutoCR));
        if (AutoCR.quotas !== undefined && AutoCR.quotas !== null && AutoCR.quotas !== '') BuildRate()
    }, [AutoCR.quotas])

    const BuildRate = () => {
        setResumen(GetResumenRate({
            plan: AutoCR.lstPlanConfig.find((x: any) => x.id === parseInt(AutoCR.plan)) ?? { id: 0, name: '', description: '', maxDayPlan: 0 } as any,
            catQuotas: AutoCR.catQuotas,
            idDiscount: AutoCR.idDiscount,
            lstCoverageExt: AutoCR.lstCoverageExt,
            lstRates: AutoCR.rates.rates,
            nQuotas: AutoCR.quotas ?? '',
            sumInsured: AutoCR.vehicleValue
        }));
    }


    const styleCss = {
        overlay: { display: "flex", justifyContent: 'center', alignItems: 'center', background: 'rgba(255, 255, 255,0.7)' }
    }

    const isValidCheked = (id: number) => (isChecked === id)

    const onChangeChk = (id: string, checked: boolean) => {
        let idDesc = id.split('_');
        if (checked) {
            setIsChecked(parseInt(idDesc[1]));
            setAutoCR({ ...AutoCR, idDiscount: parseInt(idDesc[1]), discount: 0 })
        }
        else {
            setAutoCR({ ...AutoCR, idDiscount: 0, discount: 0 })
            setIsChecked(0);
        }
    }

    const onApplyDiscount = () => {
        setValidMaxDiscount(true);
        if (AutoCR.discount > AutoCR.maxDiscount) {
            setValidMaxDiscount(false);
            return;
        }
        setOpenModalDiscount(false);
        setAutoCR({ ...AutoCR, isRate: true });
        const data = GetDataRates(AutoCR)
        http(endPoints.tarificar(AutoCR.plan))
            .post(data)
            .then((x) => {
                setAutoCR({ ...AutoCR, rates: x, isRate: false });
            })
            .catch((x: string) => {
                setAutoCR({ ...AutoCR, isRate: false });
            })
    }

    useEffect(() => {
        //setResumen(GetResumen(AutoCR));
        BuildRate()
    }, [AutoCR.rates])


    return (
        <>

            <DropDown
                label='Selección de cuotas'
                field='quotas'
                valueSelect={AutoCR.quotas}
                dataProvider={AutoCR.catQuotas}
                onChangeSelect={onChange}
            />
            <table className='tresumen-cr'>
                <tbody>
                    <tr>
                        <td width={"70%"} style={{ fontWeight: 0 }}>Prima</td>
                        <td width={"30%"} style={{ textAlign: 'right' }}>{resumen.bonusStr}</td>
                    </tr>
                    <tr style={{ fontWeight: 600 }}>
                        <td style={{ fontWeight: 0 }}>Descuento</td>
                        {AutoCR.catDiscount.length > 0 && <td onClick={() => setOpenModalDiscount(true)} style={{ textAlign: 'right', textDecorationLine: 'underline', cursor: 'pointer' }}>{resumen.descStr}</td>}
                        {AutoCR.catDiscount.length === 0 && <td style={{ textAlign: 'right' }}>{resumen.descStr}</td>}
                    </tr>
                    <tr>
                        <td width={"70%"} style={{ fontWeight: 0 }}>Prima neta</td>
                        <td width={"30%"} style={{ textAlign: 'right' }}>{resumen.bonus2Str}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 0 }}>Derecho de emisión</td>
                        <td style={{ textAlign: 'right' }}>{resumen.rightEmissionsStr}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 0 }}>Impuesto</td>
                        <td style={{ textAlign: 'right' }}>{resumen.taxStr}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: 0 }}>Financiamiento</td>
                        <td style={{ textAlign: 'right' }}>{resumen.financingStr}</td>
                    </tr>
                    <tr style={{ borderTop: '1px solid' }}>
                        <td style={{ fontWeight: 0 }}>Total</td>
                        <td style={{ textAlign: 'right', fontWeight: 0 }}>{resumen.totalStr}</td>
                    </tr >
                    <tr style={{ height: '20px' }}></tr>
                    <tr style={{ textAlign: 'center' }}>
                        <td colSpan={2}><label>Frecuencia de pago</label></td>
                    </tr>
                    {resumen.bonusfrequency?.sort((x: any, y: any) => { return x.text - y.text }).map((f) => {
                        return <tr>
                            <td style={{ fontWeight: 0 }}>{f.text}</td>
                            <td style={{ textAlign: 'right' }}>{f.value}</td>
                        </tr>
                    })}
                    <tr style={{ height: '40px' }}></tr>
                </tbody>
            </table>
            <Modal className="modal-auto-cr" isOpen={openModalDisconunt} style={styleCss} ariaHideApp={false}>
                <div className="modal-title" style={{ height: '40px' }}>
                    <span className="txt-title-modal">Descuento</span>
                </div>
                <div className="modal-body-info mt-20 mb-20" style={{}}>
                    {AutoCR.catDiscount.filter(x => x.seleccionable)?.map(x => {
                        return <div>
                            <div style={{ display: 'flex', justifyContent: 'space-around', height: '40px' }}>
                                <div style={{ width: '50%' }}>
                                    <CheckBox2
                                        label={x.nombre}
                                        field={`chkDesc_${x.codigo}`}
                                        value={isValidCheked(x.codigo)}
                                        key={x.codigo}
                                        onChange={onChangeChk}
                                        onClickLabel={() => { }}
                                        isReadOnly={(x.codigo === idDiscountAutoNew && AutoCR.vehicleStatus !== '1')}
                                    />
                                </div>
                                <div style={{ width: '15%' }}>
                                    {x.codigo === idDiscountManual && isValidCheked(idDiscountManual) && <Input onlyInput={true} id='discount' field='discount' type='number' value={AutoCR.discount.toString()} label='' onChange={changeHandler} isReadOnly={!isValidCheked(idDiscountManual)} maxValue={AutoCR.maxDiscount} />}
                                    {x.codigo !== idDiscountManual && <span style={{ color: '#4D4D4D' }}>{x.porcentaje}%</span>}

                                </div>
                                <div style={{ width: '5%' }}>
                                    {x.codigo === idDiscountManual && isValidCheked(idDiscountManual) && <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        <Tooltip id='discountManual' text={`El Máximo descuento para este plan es de  ${AutoCR.maxDiscount.toString()}%`} title='Máximo descuento' ></Tooltip> </div>}
                                </div>
                            </div>
                            {/* {x.codigo === idDiscountManual && !validMaxDiscount && <label style={{ color: '#FF5F49' }}>Máximo descuento {AutoCR.maxDiscount.toString()}%</label>} */}
                        </div>
                    })}
                </div>
                <div className="modal-footer mt-20" >
                    <div style={{ width: '100%' }} >
                        <button className="modal-btn-close" style={{ background: '#008866' }} onClick={onApplyDiscount}>Aplicar</button>

                    </div>
                    <div style={{ width: '100%' }}>
                        <button className="modal-btn-close" onClick={() => setOpenModalDiscount(false)}>Cancelar</button>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export { Step5 }